export enum ApprovalMatrixStatus {
	Pending = 1,
	Approved = 2,
	Rejected = 3,
}
